// extracted by mini-css-extract-plugin
export default {"component":"bfCEx","tooltip":"_2SpDV"};